export default __webpack_public_path__ + "static/media/ic_arrow_right.bd23bdcc.svg";